import CompareVirtualTourAPS from './CompareVirtualTourAPS';

export default CompareVirtualTourAPS;
